import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import classes from "./ManageGroup.module.scss";
import { groupManagement } from "../../../../utils/mainTabs/admin/groupManagement/groupManagement";
import ManageGroupHeader from "./ManageGroupHeader/ManageGroupHeader";
import MangeGroupSubGroup from "./ManageGroupSubGroup/MangeGroupSubGroup";
import ManageMandatoryLearnings from "./ManageMandatoryLearnings/ManageMandatoryLearnings";
import { FormattedMessage } from "react-intl";

const ManageGroup = ({ tenantName, handleSearchQuery }) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      try {
        localStorage.removeItem("manageUsersCount");
        localStorage.removeItem("manageSubgroupsCount");
        localStorage.removeItem("groupName");
      } catch (error) {
        console.log(error);
      }
    };
  }, []);

  return (
    <BoxLayout>
      <div className={classes.manageUserGroup}>
        <h4 className={classes.groupNameText}><FormattedMessage id="USERGROUP_USERGROUPNAME" /></h4>
        <ManageGroupHeader
          location={location}
          navigate={navigate}
          params={params}
          tenantName={tenantName}
        />

        {location?.pathname?.includes(
          `${groupManagement?.path(tenantName)}/manageUsers`
        ) && (
          <MangeGroupSubGroup
            navigate={navigate}
            params={params}
            location={location}
            searchLabel="Add New User To This Group"
            searchPlaceHolder="Search User To Add"
            tenantName={tenantName}
            handleSearchQuery={handleSearchQuery}
          />
        )}
        {location?.pathname?.includes(
          `${groupManagement?.path(tenantName)}/manageSubgroups`
        ) && (
          <MangeGroupSubGroup
            navigate={navigate}
            params={params}
            location={location}
            searchLabel="Search Subgroup To Add"
            searchPlaceHolder="Search Subgroup To Add"
            tenantName={tenantName}
            handleSearchQuery={handleSearchQuery}
          />
        )}
        {location?.pathname?.includes(
          `${groupManagement?.path(tenantName)}/manageMandatoryLearnings`
        ) && (
          <ManageMandatoryLearnings params={params} tenantName={tenantName} />
        )}
      </div>
    </BoxLayout>
  );
};

export default ManageGroup;
